// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteSearchModelResponse {
    static getAttributeTypeMap() {
        return SiteSearchModelResponse.attributeTypeMap;
    }
}
SiteSearchModelResponse.discriminator = undefined;
SiteSearchModelResponse.additionalProperties = false;
SiteSearchModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "SiteSearchResponseModel"
    },
];
//# sourceMappingURL=siteSearchModelResponse.js.map